import React from 'react';
import { fetchModels } from 'models/ownership';
import { fetchTestDrivePrivacy } from 'models/contract';
import { fetchCarTourShops, clearTestDriveForm } from 'models/testDrive';

export default {
	path: '/appointment',
	components: () => [import('./component')],
	render: ([EmbedTestDrive]) => <EmbedTestDrive />,
	onEnter: async ({ store }) => {
		if (sessionStorage.getItem('preserveTestDriveFormData')) {
			sessionStorage.removeItem('preserveTestDriveFormData');
		} else {
			store.dispatch(clearTestDriveForm());
		}
		await Promise.all([
			store.dispatch(fetchModels()),
			store.dispatch(fetchTestDrivePrivacy()),
			store.dispatch(fetchCarTourShops()),
		]);
	},
};
